import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import SelectField from './SelectField';
import SelectField_dropdown_updates from '../SelectField.dropdown_updates';
export default withFeatureBranch({
    dropdown_updates: SelectField_dropdown_updates,
})(SelectField);
//# sourceMappingURL=index.js.map